import { Button } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSelectedRoom } from '../../../layouts/configurations/configurationSlice';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../utils/formUtils';
import { saveOrUpdateRoomConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceRoomTabDoorCamera = (props) => {
  const { dcInfo, roomId, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    ip: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    port: {
      value: '',
      fieldName: 'Port',
      errors: {},
      validations: [],
    },
  });

  useEffect(() => {
    if (dcInfo) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = dcInfo[field];
      }
      setFormData(currFields);
    }
  }, [dcInfo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(true)) {
      try {
        dispatch(stepUpLoaderCount());
        const payload = {};

        for (let field in formData) {
          payload[field] = formData[field].value;
        }
        await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'DC', payload);
        dispatch(fetchSelectedRoom(selectedHotel, roomId));
        notificationManager('success', 'Door Lock details saved successfully');
      } catch (error) {
        if (error?.message) {
          notificationManager('danger', error?.message);
        } else {
          notificationManager('danger', 'Door Lock details save failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const validate = (isUpdatedField) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedField ? updatedFields : isUpdatedField);
    if (isUpdatedField) setFormData(updatedFields);
    return isValid;
  };

  const onChangeIP = (e) => {
    e.validations = e.value ? ['validIP'] : [];
    setFormData({ ip: e });
  };

  return (
    <form className='global-tab' noValidate onSubmit={handleSubmit}>
      <div className='container px-0 d-flex align-items-end flex-column h-100'>
        <div className='row w-100 d-flex mt-2'>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <CustomTextField item={formData.ip} handleInputChange={(e) => onChangeIP(e)} />
            </div>
            <div className='col-md-4 mb-3'>
              <CustomTextField
                item={formData.port}
                handleInputChange={(e) => {
                  setFormData({ port: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row d-flex mt-auto w-100 pb-4'>
          <div>
            <Button
              size='large'
              variant='contained'
              color='primary'
              className='me-3'
              type='submit'
              disabled={!validate(false)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceRoomTabDoorCamera;
